import AjaxService from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';
import { getCurrentUserId } from '../services/store-service';

export const fetchDiscussions = ({ projectId, offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: `chats`,
        params: {
            project_id: projectId,
            offset,
            limit
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const createDiscussion = ({ type, project, name, description, message_id, members = [] }) => {
    return AjaxService({
        method: 'post',
        url: 'chats',
        data: {
            type,
            project_id: project,
            message_id,
            name,
            description,
            member_ids: [...new Set(members.map(user => user.id || user))].filter(u => u !== getCurrentUserId()).join(',')
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchDiscussion = discussionId => {
    return AjaxService({
        method: 'get',
        url: `chats/${discussionId}`
    })
    .then(response => response.data)
    .catch(error => handleServerError(error, {
        silent: true
    }));
}

export const updateDiscussion = (discussionId, { name, description }) => {
    return AjaxService({
        method: 'put',
        url: `chats/${discussionId}`,
        data: {
            name,
            description
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeDiscussion = (discussionId, force) => {
    return AjaxService({
        method: 'delete',
        url: `chats/${discussionId}`,
        params: { force }
    })
    .then(response => response.data);
}

export const muteDiscussion = discussionId => {
    return AjaxService({
        method: 'post',
        url: `chats/${discussionId}/mute`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const unmuteDiscussion = discussionId => {
    return AjaxService({
        method: 'post',
        url: `chats/${discussionId}/unmute`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const leaveDiscussion = discussionId => {
    return AjaxService({
        method: 'post',
        url: `chats/${discussionId}/leave`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const addDiscussionMembers = (discussionId, members) => {
    return AjaxService({
        method: 'put',
        url: `chats/${discussionId}/members`,
        data: {
            members: members.map(user => user.id)
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeDiscussionMembers = (discussionId, members) => {
    return AjaxService({
        method: 'delete',
        url: `chats/${discussionId}/members`,
        data: { members }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const pinMessage = (discussionId, message_id) => {
    return AjaxService({
        method: 'post',
        url: `chats/${discussionId}/pin`,
        data: { message_id }
    })
    .then(response => response.data)
    .catch(handleServerError);
}
